import { render, staticRenderFns } from "./ComplianceGraphQLMediatorAPI.vue?vue&type=template&id=3c5d03ec&scoped=true&"
import script from "./ComplianceGraphQLMediatorAPI.vue?vue&type=script&lang=js&"
export * from "./ComplianceGraphQLMediatorAPI.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceGraphQLMediatorAPI.vue?vue&type=style&index=0&id=3c5d03ec&prod&lang=css&"
import style1 from "./ComplianceGraphQLMediatorAPI.vue?vue&type=style&index=1&id=3c5d03ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d03ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VProgressLinear,VRow})
